<template>
  <div class="ml-15 mr-15 mt-10">
    <v-row dense class="text-lefth">
      <v-col cols="12" sm="12" md="12">
        <v-banner color="blue-grey lighten-5" class="mb-4 black--text" shaped single-line align="left">
          Información de paciente
        </v-banner>
      </v-col>
    </v-row>

    <v-row dense class="text-lefth">
      <v-col cols="3" lg="3" md="3" sm="12">
        <strong>Id Paciente: </strong>
        {{ model.idPatient }}
      </v-col>
      <v-col cols="3" lg="3" md="4" sm="12">
        <strong>Nombre del paciente: </strong> {{ model.name }}
        {{ model.firstLastName }} {{ model.secondLastName }}
      </v-col>
      <v-col cols="3" lg="3" md="4" sm="12">
        <strong>CURP: </strong> {{ model.curp }}
      </v-col>

      <v-col cols="3" lg="3" md="4" sm="12">
        <strong>Edad: </strong>
        {{ $utilFront.obtainAgeWithLabel(model.birthDate) }}
      </v-col>
    </v-row>

    <v-row dense class="text-lefth">
      <v-col cols="3" lg="3" md="3" sm="12">
        <strong>Número de afiliación: </strong>
        {{ model.patientNumber }}
      </v-col>
      <v-col cols="3" lg="3" md="3" sm="12">
        <strong>Aseguradora: </strong>
        {{ model.healthInsuranceName }}
      </v-col>
      <v-col cols="3" lg="3" md="3" sm="12">
        <strong>Fecha de nacimiento: </strong>
        {{ patientBirth }}
      </v-col>
      <v-col cols="3" lg="3" md="3" sm="12">
        <strong>Entidad de nacimiento: </strong>
        {{ model.nameBirthFederalEntity }}
      </v-col>
    </v-row>
    <v-row dense class="text-lefth">
      <v-col cols="3" lg="3" md="3" sm="12">
        <strong>Número telefónico: </strong>
        {{ model.phone }}
      </v-col>
      <v-col cols="3" lg="3" md="3" sm="12">
        <strong>Correo electrónico: </strong>
        {{ !model.email || model.email === 'null' ? 'N/A' : model.email }}
      </v-col>
      <v-col cols="6" lg="6" md="6" sm="12">
        <strong>Domicilio: </strong>
        {{ model.street }}, {{ model.location }}. {{ model.postalCode }}.
        {{ model.nameMunicipalityAddress }},
        {{ model.nameFederalEntityAddress }}
      </v-col>
    </v-row>
    <v-row dense class="text-lefth mt-4">
      <v-col cols="12" sm="12" md="12">
        <v-banner color="blue-grey lighten-5" class="mb-4 black--text" shaped single-line align="left">
          Información de la interpretación
        </v-banner>
      </v-col>
    </v-row>


    <v-row dense class="text-lefth">
      <v-col cols="3" lg="3" md="3" sm="12">
        <strong class="mr-2">Id interpretacion: </strong>
        {{ model.idInterpretation || '- - -' }}
      </v-col>
      <v-col cols="3" lg="3" md="3" sm="12">
        <strong>Id Mastógrafo: </strong>
        {{ model.branchOffice }}
      </v-col>

      <v-col cols="3" lg="3" md="3" sm="12">
        <strong>BI-RADS: </strong>
        <v-chip :color="$utilFront.getColorBirads(birads)">
          {{ $utilFront.nonEmpty(model.idInterpretation) ? birads : 'REPETIR' }}
        </v-chip>
      </v-col>
    </v-row>
    <v-row dense class="text-lefth">
      <v-col cols="3" md="3" sm="12">
        <strong>Id externo: </strong>
        {{ model.idExternalInterpreter || '- - -' }}
      </v-col>
      <v-col cols="3" md="3" sm="12">
        <strong>Médico intérprete: </strong>
        {{ model.interpreterName || '- - -' }}
      </v-col>
      <v-col cols="3" md="3" sm="12">
        <strong>Fecha de interpretación: </strong>
        {{ $utilFront.nonEmpty(model.idInterpretation) ? interpretationDate : '- - -' }}
      </v-col>
      <v-col cols="3" md="3" sm="12">
        <strong>Fecha de estudio: </strong>
        {{ studyDate }}
      </v-col>
    </v-row>

    <v-row dense class="text-lefth mt-4">
      <v-col cols="12" sm="12" md="12">
        <v-banner color="blue-grey lighten-5" class="mb-4 black--text" shaped single-line align="left">
          Información de hallazgos
        </v-banner>
      </v-col>
    </v-row>

    <v-row align="center" justify="center">
      <v-col cols="6">
        <v-data-table :headers="headersFinding" :items="findings" dense :items-per-page="100" :footer-props="{
          'items-per-page-text': 'Elementos por página',
          'items-per-page-all-text': 'Todo',
        }" no-results-text="Sin resultados coincidentes con la búsqueda" loading-text="Cargando..."
          no-data-text="Sin resultados disponibles" calculate-widths fixed-header height="auto" hide-default-footer>

          <template v-slot:[`item.findingText`]="{ item }">
            {{  $utilFront.nonEmpty(model.idInterpretation) ? item.findingText : '- - -' }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="js">

import { CamujalService } from "@/app/services";
export default {
  name: "PatientInformation",
  props: {
    dataForModal: Object,
    dialog: Boolean,
  },
  data() {
    return {
      model: {},
      patientAge: "",
      patientBirth: "",
      interpretationDate: "",
      studyDate: "",
      birads: "",
      headersFinding: [
        { text: "Hallazgo", value: "typeFindingName", align: "center" },
        { text: "Ubicación", value: "locationName", align: "center" },
        { text: "Valor", value: "findingText", align: "center" }
      ],
      findings: [],
      jsonSend: {}
    };
  },
  mounted() {
    this.getDataConsulty();
  },
  watch: {
    dialog: function () {
      if (!this.dialog) {
        this.model = {};
      } else {
        this.getDataConsulty();
      }
    }
  },
  methods: {
    getDataConsulty() {
      this.model = {};
      CamujalService.getHistorySend(this.dataForModal).then(({ data }) => {
        this.findings = data.findings;
        this.model = data;
        this.patientAge = this.$utilFront.obtainAgeWithLabel(
          this.model.birthDate
        );
        this.patientBirth = this.$utilFront.formatDate(
          this.model.birthDate
        );
        this.interpretationDate = this.$utilFront.formatDate(
          this.model.interpretationRegistrationDate
        );
        this.studyDate = this.$utilFront.formatDate(
          this.model.studyStartDate
        );



        if (this.$utilFront.nonEmpty(data.jsonSend)) {


          this.jsonSend = JSON.parse(data.jsonSend);
          this.model.idPatient = this.jsonSend.id_paciente;
          this.model.name = this.jsonSend.nombre;
          this.model.firstLastName = this.jsonSend.apellidoP;
          this.model.secondLastName = this.jsonSend.apellidoM;
          this.model.curp = this.jsonSend.curp;
          this.model.patientNumber = this.jsonSend.num_afiliacion;
          this.model.phone = this.jsonSend.telefono;
          this.model.email = this.jsonSend.email;
          this.model.branchOffice = this.jsonSend.mastografo;
          this.model.birads = this.jsonSend.birads;



          this.findings = this.model.findings.map((item) => {


            if (this.$utilFront.nonEmpty(this.model.idInterpretation)) {
              const value = this.jsonSend[item.parameterName];
              item.findingText = value === 1 ? "SI" : "NO"
            }

            return item;
          });
        }
        this.birads = this.model.birads;

      })
    },
    closeDialog() {

    }
  },
};
</script>

<style></style>
